import VConsole from 'vconsole'
import Vue from "vue";
const vConsole = process.env.environment === 'prod' ? '' : new VConsole()
Vue.use(vConsole);